import React, { FC, ReactNode } from 'react';
import { styled } from 'linaria/react';
import { useRouter } from 'next/router';
import { Heading, Text, Icon, useBreakpoint, Button, HeadingProps } from '@mtsbank/ui-kit';
import { useTheme, withTheme } from '@shared/lib';
import { Content } from '@shared/ui/atoms';
import { noticeErrorTypeMapping, NoticeType } from '@shared/config/notice';
const MIN_ICON_SIZE = 80;
const MAX_ICON_SIZE = 80;
export interface NoticeProps {
  fluid?: boolean;
  type?: NoticeType;
  icon?: string;
  title?: string;
  message?: string;
  amount?: string;
  date?: string;
  providerName?: string;
  headingValue?: HeadingProps['h'];
  mobHeadingValue?: HeadingProps['h'];
  iconSize?: number;
  mobIconSize?: number;
  marginTop?: string | number;
  isRedirectButtonToMainPage?: boolean;
  children?: ReactNode;
}
export const Notice: FC<NoticeProps> = ({
  fluid,
  type,
  icon,
  title,
  message,
  amount,
  date,
  providerName,
  children,
  headingValue,
  mobHeadingValue,
  iconSize = MAX_ICON_SIZE,
  mobIconSize = MIN_ICON_SIZE,
  marginTop,
  isRedirectButtonToMainPage
}) => {
  const router = useRouter();
  const {
    isMobile
  } = useBreakpoint();
  const theme = useTheme();
  const iconType = icon || noticeErrorTypeMapping[type as NoticeType] || noticeErrorTypeMapping[NoticeType.ERROR];
  const calculatedIconSize = isMobile ? mobIconSize : iconSize;
  const resultHeadingValue = isMobile ? mobHeadingValue || 3 : headingValue || 2;
  const viewBox = `0 0 ${iconSize} ${iconSize}`;
  const handleClick = () => {
    router.push('/cyber');
  };
  return <OuterWrapper fluid={fluid} marginTop={marginTop as number}>
      <IconWrapper iconSize={iconSize} mobIconSize={mobIconSize}>
        <Icon icon={iconType} width={calculatedIconSize} height={calculatedIconSize} viewBox={viewBox} />
      </IconWrapper>
      <Wrapper>
        {title && <Title h={resultHeadingValue} align="center" fontWeight="medium">
            {title}
          </Title>}
        {message && <Message align="center" color={theme.colors.text.grey300}>
            {message}
          </Message>}
        {!amount && <Amount align="center">{`${amount} ₽`}</Amount>}
        {providerName && <ProviderName align="center" color="#9F9F9F">
            {providerName}
          </ProviderName>}
        {date && <Date align="center" color="#9F9F9F">
            {date}
          </Date>}
        {isRedirectButtonToMainPage && <Content marginTop={32}>
            <Button onClick={handleClick} variant="secondary">
              На главную
            </Button>
          </Content>}
      </Wrapper>
      {children && <ChildrenWrapper color={theme.colors.text.grey300}>{children}</ChildrenWrapper>}
    </OuterWrapper>;
};
const _exp = /*#__PURE__*/() => Heading;
const _exp2 = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSExtended;
const _exp3 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.white;
const Title = withTheme(/*#__PURE__*/styled(_exp())({
  name: "Title",
  class: "t1lao01",
  propsAsIs: true,
  vars: {
    "t1lao01-0": [_exp2()],
    "t1lao01-1": [_exp3()]
  }
}));
const _exp4 = /*#__PURE__*/() => Text;
const _exp5 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.white;
const Message = withTheme(/*#__PURE__*/styled(_exp4())({
  name: "Message",
  class: "mnaq2y7",
  propsAsIs: true,
  vars: {
    "mnaq2y7-0": [_exp5()]
  }
}));
const _exp6 = /*#__PURE__*/() => Text;
const Date = /*#__PURE__*/styled(_exp6())({
  name: "Date",
  class: "d110tv57",
  propsAsIs: true
});
const _exp7 = /*#__PURE__*/() => Text;
const ProviderName = /*#__PURE__*/styled(_exp7())({
  name: "ProviderName",
  class: "pkjynvf",
  propsAsIs: true
});
const _exp8 = /*#__PURE__*/() => Text;
const _exp9 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.white;
const _exp0 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.sm;
const Amount = withTheme(/*#__PURE__*/styled(_exp8())({
  name: "Amount",
  class: "a1vmwly5",
  propsAsIs: true,
  vars: {
    "a1vmwly5-0": [_exp9()],
    "a1vmwly5-1": [_exp0(), "px"]
  }
}));
const _exp1 = /*#__PURE__*/() => ({
  fluid
}) => fluid ? 0 : `0 16px`;
const OuterWrapper = /*#__PURE__*/styled('div')({
  name: "OuterWrapper",
  class: "ok0tarm",
  propsAsIs: false,
  vars: {
    "ok0tarm-0": [_exp1()]
  }
});
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "w1vo1hew",
  propsAsIs: false
});
const _exp11 = /*#__PURE__*/() => ({
  mobIconSize
}) => mobIconSize;
const _exp13 = /*#__PURE__*/() => ({
  iconSize
}) => iconSize;
const IconWrapper = /*#__PURE__*/styled('div')({
  name: "IconWrapper",
  class: "i1dth1y4",
  propsAsIs: false,
  vars: {
    "i1dth1y4-0": [_exp11(), "px"],
    "i1dth1y4-1": [_exp13(), "px"]
  }
});
const ChildrenWrapper = /*#__PURE__*/styled('div')({
  name: "ChildrenWrapper",
  class: "cnra2nl",
  propsAsIs: false
});

require("./Notice.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./Notice.tsx");